// Ключи per-TAB меток организатора в sessionStorage. Листовой модуль без импортов: его читают и
// `project-role.ts`, и `auth.ts` (clearAuth), а прямой импорт между ними дал бы цикл.

// Owner previewing the organizer view in THIS tab — never localStorage, which all tabs share.
export const ORGANIZER_PREVIEW_KEY = 'organizerPreviewProjectId';
// The URL the preview was entered from, so «Выйти из режима» returns there.
export const ORGANIZER_PREVIEW_RETURN_KEY = 'organizerPreviewReturnUrl';
// Проект, в который ЭТУ вкладку впустил вход по ссылке организатора.
export const COORDINATOR_ENTRY_KEY = 'coordinatorEntryProjectId';
